var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_18766",
    "data-name": "Group 18766",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.283,
    height: 24.822,
    viewBox: "0 0 22.283 24.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.915,
    y1: 6.614,
    x2: -0.383,
    y2: 5.945,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.076,
    y1: 17.098,
    x2: -1.305,
    y2: 17.098,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.862,
    y1: 10.863,
    x2: -0.501,
    y2: 9.093,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: 13.583,
    x2: 0.421,
    y2: 12.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22520",
    "data-name": "Path 22520",
    d: "M20.419,17.535a1.937,1.937,0,0,0-.446,1.356V40.234a1.935,1.935,0,0,0,.446,1.356l.071.069L32.446,29.7v-.282L20.49,17.465Z",
    transform: "translate(-19.973 -17.152)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22521",
    "data-name": "Path 22521",
    d: "M36.884,33.98,32.9,29.992v-.282l3.987-3.987.09.052L41.7,28.459c1.348.766,1.348,2.02,0,2.786l-4.722,2.683Z",
    transform: "translate(-20.425 -17.44)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22522",
    "data-name": "Path 22522",
    d: "M36.539,34.077,32.462,30,20.435,42.028a1.57,1.57,0,0,0,2.006.059l14.1-8.01",
    transform: "translate(-19.989 -17.59)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22523",
    "data-name": "Path 22523",
    d: "M36.539,25.475l-14.1-8.01a1.57,1.57,0,0,0-2.006.059L32.462,29.552Z",
    transform: "translate(-19.989 -17.14)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8060",
    "data-name": "Group 8060",
    transform: "translate(0 16.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22524",
    "data-name": "Path 22524",
    d: "M36.449,34.132,22.441,42.091a1.607,1.607,0,0,1-1.934.011h0l-.072.071h0l.071.07h0a1.607,1.607,0,0,0,1.934-.011l14.1-8.01Z",
    transform: "translate(-19.989 -34.132)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22525",
    "data-name": "Path 22525",
    d: "M20.419,42.269a1.935,1.935,0,0,1-.446-1.356v.142a1.933,1.933,0,0,0,.446,1.355l.072-.071Z",
    transform: "translate(-19.973 -34.369)",
    opacity: 0.12,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22526",
    "data-name": "Path 22526",
    d: "M41.841,31.254l-4.812,2.734.09.09,4.722-2.683A1.694,1.694,0,0,0,42.852,30h0A1.8,1.8,0,0,1,41.841,31.254Z",
    transform: "translate(-20.569 -17.59)",
    opacity: 0.12,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22527",
    "data-name": "Path 22527",
    d: "M22.425,17.606,41.245,28.3a1.8,1.8,0,0,1,1.011,1.253h0a1.691,1.691,0,0,0-1.011-1.394L22.425,17.465c-1.349-.766-2.452-.129-2.452,1.415v.142C19.973,17.477,21.076,16.84,22.425,17.606Z",
    transform: "translate(-19.973 -17.14)",
    fill: "#fff",
    opacity: 0.25,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.aa6e569d.svg";
export { ForwardRef as ReactComponent };